export const AffiliatePartners = {
  BOOKING_COM: "booking-com",
  CLICKTRIPZ: "clicktripz"
} as const;

export type AffiliatePartners =
  (typeof AffiliatePartners)[keyof typeof AffiliatePartners];

export const BOOKING_COM_AID = {
  SEARCH: "2265814",
  CONFIRMATION_PAGE_BANNER: "2261544",
  CONFIRMATION_PAGE_REDIRECT: "2261543",
  RESULTS_PAGE_REDIRECT: "2261756",
  NAVIGATION_MENU: "2262103",
  SEARCH_ZA: "2262105",
  ROUTE_PAGE_SEM: "2262106",
  CITY_PAGE_SEO: "2262107",
  ROUTE_PAGE_SEO: "2262106" // Temporary fallback. Waiting an exlusive AID
} as const;
